import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@finance/components/ui/dialog";
import { Button } from "@finance/components/ui/button";

// Read-only "see the final document before issuing/saving" view. Close to keep editing, confirm to proceed.
export function DocumentPreview({ open, onOpenChange, title, meta = [], columns = [], rows = [], totals = [], onConfirm, confirmLabel = "Confirm & Save", note }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="document-preview">
        <DialogHeader><DialogTitle className="font-display">Preview — {title}</DialogTitle></DialogHeader>
        <div className="rounded-sm border border-gray-200 bg-white p-6">
          <div className="mb-5 grid grid-cols-2 gap-x-8 gap-y-1 text-sm">
            {meta.filter(([, v]) => v !== undefined && v !== null && v !== "").map(([label, value]) => (
              <div key={label} className="flex justify-between border-b border-gray-50 py-1"><span className="text-gray-400">{label}</span><span className="font-medium text-gray-900">{value}</span></div>
            ))}
          </div>
          <table className="w-full text-sm">
            <thead><tr className="lx-label border-b border-gray-200">{columns.map((c) => <th key={c.key} className={`px-2 py-1.5 ${c.align === "right" ? "text-right" : "text-left"}`}>{c.label}</th>)}</tr></thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={columns.length} className="px-2 py-6 text-center text-gray-400">No line items yet.</td></tr>}
              {rows.map((r, i) => (
                <tr key={i} className="border-b border-gray-100" data-testid={`preview-row-${i}`}>
                  {columns.map((c) => <td key={c.key} className={`px-2 py-1.5 ${c.align === "right" ? "text-right lx-num" : ""}`}>{r[c.key]}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="mt-4 flex flex-wrap justify-end gap-8 text-sm">
            {totals.map(([label, value, strong]) => (
              <div key={label}><span className="lx-label">{label}</span> <span className={`lx-num ml-2 ${strong ? "font-bold text-[#1B4383]" : ""}`}>{value}</span></div>
            ))}
          </div>
          {note && <p className="mt-4 text-xs text-gray-400">{note}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" data-testid="preview-close" onClick={() => onOpenChange(false)}>Close &amp; keep editing</Button>
          {onConfirm && <Button className="bg-[#1B4383] hover:bg-[#122E5C]" data-testid="preview-confirm" onClick={onConfirm}>{confirmLabel}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
